import { useNavigate } from "react-router-dom";
import { content } from "../../data/content";
import type { Theme } from "../../types";
import styles from "./Footer.module.scss";

interface FooterProps {
  theme: Theme;
}

const EXPLORE = [
  ["home", "/"],
  // ["work", "/work"],
  // ["notes", "/notes"],
  ["now", "/now"],
  ["about", "/about"],
] as const;

function FooterRow({
  theme,
  left,
  right,
}: {
  theme: Theme;
  left: string;
  right: string;
}) {
  return (
    <div
      className={styles.row}
      style={{ borderColor: theme.rule, color: theme.fg }}
    >
      <span style={{ color: theme.muted }}>{left}</span>

      <span className={right === "/michellecelinahahn" ? styles.blurred : ""}>
        {right}
      </span>
    </div>
  );
}

export function Footer({ theme }: FooterProps) {
  const navigate = useNavigate();
  return (
    <footer
      className={styles.footer}
      style={{
        borderTopColor: theme.rule,
        background: theme.dark
          ? "rgba(58,47,39,0.85)"
          : "rgba(244,238,223,0.85)",
      }}
    >
      <div className={styles.grid}>
        <div>
          <div className={styles.brand} style={{ color: theme.fg }}>
            miceha<span style={{ color: theme.acc }}>.</span>codes
          </div>
          <p className={styles.tagline} style={{ color: theme.muted }}>
            A junior dev's scrapbook, kept in plain monospace. Written and
            rewritten, slowly, near Koblenz.
          </p>
        </div>

        <div>
          <div className={styles.colTitle} style={{ color: theme.muted }}>
            elsewhere
          </div>
          <div className={styles.colBody}>
            {content.links.map((l, i) => (
              <FooterRow key={i} theme={theme} left={l.label} right={l.href} />
            ))}
          </div>
        </div>

        <div>
          <div className={styles.colTitle} style={{ color: theme.muted }}>
            explore
          </div>
          <div className={styles.colBody}>
            {EXPLORE.map(([label, path], i) => (
              <div
                key={i}
                className={styles.row}
                style={{
                  borderColor: theme.rule,
                  color: theme.fg,
                  cursor: "pointer",
                }}
                onClick={() => navigate(path)}
              >
                <span style={{ color: theme.muted }}>{label}</span>
                <span>{path}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className={styles.colTitle} style={{ color: theme.muted }}>
            meta
          </div>
          <div className={styles.colBody}>
            <FooterRow theme={theme} left="built" right="by hand" />
            <FooterRow theme={theme} left="set in" right="JetBrains Mono" />
            {/* <FooterRow theme={theme} left="since" right="June 2026" /> */}
            <FooterRow theme={theme} left="updated" right="June 2026" />
          </div>
        </div>
      </div>

      <div
        className={styles.bottom}
        style={{ borderTopColor: theme.rule, color: theme.muted }}
      >
        <span>© 2026 miceha.codes · made with care</span>

        <span className={styles.bottomLinks}>
          <span onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            ↑ top
          </span>
        </span>
      </div>
    </footer>
  );
}
